// packages
import React from 'react';

// types
import { FormComponentProps } from 'components/shared/CRUD/TableCRUDLayout';
import { ClaResponse } from 'generated/index';

// components
import { ClaMaintenanceForm } from '../ClaMaintenanceForm/ClaMaintenanceForm';

export const ClaMaintenanceDrawer: React.FC<
  FormComponentProps<ClaResponse>
> = ({ handleClose, rowId, rows = [] }) => {
  const rowData = rowId ? rows.find((row) => row.claId === rowId) : undefined;

  return (
    <ClaMaintenanceForm
      handleClose={handleClose}
      rowData={rowData}
      rows={rows}
    />
  );
};
